<div id="used-client-offcut-list">
  <mat-table fusePerfectScrollbar class="used-client-offcut-table" #table [dataSource]="dataSource">
    <!-- Height Column -->
    <ng-container cdkColumnDef="height">
      <mat-header-cell i18n *cdkHeaderCellDef>Длина (мм)</mat-header-cell>
      <mat-cell *cdkCellDef="let item">
        <p class="text-truncate">{{ item.height }}</p>
      </mat-cell>
    </ng-container>

    <!-- Width Column -->
    <ng-container cdkColumnDef="width">
      <mat-header-cell i18n *cdkHeaderCellDef>Ширина (мм)</mat-header-cell>
      <mat-cell *cdkCellDef="let item">
        <p class="text-truncate">{{ item.width }}</p>
      </mat-cell>
    </ng-container>

    <!-- Count Column -->
    <ng-container cdkColumnDef="count">
      <mat-header-cell i18n *cdkHeaderCellDef>Количество</mat-header-cell>
      <mat-cell *cdkCellDef="let item">
        <p class="text-truncate">{{ item.count }}</p>
      </mat-cell>
    </ng-container>

    <!-- Area Column -->
    <ng-container cdkColumnDef="area">
      <mat-header-cell i18n *cdkHeaderCellDef>Площадь (кв.м.)</mat-header-cell>
      <mat-cell *cdkCellDef="let item">
        <p class="text-truncate">{{ item.width * item.height * 1e-6 * item.count | formatNumber : 2 }}</p>
      </mat-cell>
    </ng-container>

    <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *cdkRowDef="let item; columns: displayedColumns; let rowIndex = index" class="used-client-offcut">
    </mat-row>
  </mat-table>
</div>
